module.exports = __webpack_public_path__ + "img/hr-curved-rail-vertical-right-top-stone-path-background.fea76ee1.png";